import { FileBasic } from '@commenda/types/src/file/types';
import { ServiceRequestDetails } from '@commenda/types/src/service-request/types';
import { LegacyDocumentType } from '@prisma/client';
import { useEffect, useState } from 'react';

export const useServiceRequestFile = (
  serviceRequest: ServiceRequestDetails,
  documentType: LegacyDocumentType,
  type?: 'corporation' | 'subsidiary',
  taskId?: number
) => {
  const [file, setFile] = useState<FileBasic | null>(null);

  useEffect(() => {
    const document = serviceRequest?.[
      type ?? 'corporation'
    ]?.corporationDocuments?.find((doc) => {
      if (taskId) {
        return (
          doc.documentType === documentType &&
          doc.files?.filter((file) => file.serviceRequestTaskId === taskId)
        );
      }
      return doc.documentType === documentType;
    });

    // We are sorting the files in descending order of id to get the latest file
    setFile(document?.files?.sort((a, b) => b.id - a.id)?.[0] || null);
  }, [serviceRequest, documentType, taskId]);

  return [file, setFile] as const;
};

export const useServiceRequestFiles = (
  serviceRequest: ServiceRequestDetails,
  documentType: LegacyDocumentType
) => {
  const [files, setFiles] = useState<FileBasic[] | null>(null);

  useEffect(() => {
    const documents = serviceRequest?.corporation?.corporationDocuments?.filter(
      (doc) => doc.documentType === documentType
    );

    setFiles(documents?.flatMap((doc) => doc.files) || null);
  }, [serviceRequest, documentType]);

  return [files, setFiles] as const;
};
